module.exports = __webpack_public_path__ + "static/media/26UNRWA5.3c37f2af.jpg";